<template>
  <div class="main-center-content">
    <top-image-container image-url="static/images/bg/news-bg.jpg"></top-image-container>
    <div class="main-container margin-gap-v" style="margin-top: 20px;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>新闻中心</el-breadcrumb-item>
        <el-breadcrumb-item>{{currentSortName}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-container style="margin-top: 20px;">
        <el-aside width="200px">
          <el-card :body-style="{ padding: '0px' }">
            <div class="left-nav-list">
              <div class="title">新闻中心</div>
              <div :class="(currentSortId===item.id)?'left-nav-item on':'left-nav-item'"
                   v-for="(item,index) in newsSorts" :key="index" v-on:click="sortChange(item.id)">
                {{item.name}}
              </div>
            </div>
          </el-card>
        </el-aside>
        <el-main>
          <div style="margin-left: 10px;">
            <el-card>
              <router-view></router-view>
            </el-card>
          </div>
        </el-main>
      </el-container>
    </div>
  </div>
</template>
<script>
  import TopImageContainer from 'src/components/TopImageContainer'
  import NewsList from 'src/components/NewsList'
  import {mapState} from 'vuex'

  export default {
    data () {
      return {
        sortList: []
      }
    },
    props: {},
    components: {
      TopImageContainer,
      NewsList
    },
    computed: mapState({
      newsSorts: state => state.newsSorts,
      currentSortName: state => state.currentSortName,
      currentSortId: state => state.currentSortId
    }),
    mounted () {
      this.$nextTick(function () {

      })
    },
    methods: {
      sortChange (sortId) {
        this.$router.push({
          name: 'NewsList',
          query: {
            sortId: sortId
          }
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/news/index.vue